import { gql } from '@apollo/client';

export const MAX_CREDITS = gql`
    query MaxCredits($valueWithoutAdditional: ABMoneyInput!) {
        maxCredits(valueWithoutAdditional: $valueWithoutAdditional)
    }
`;
